import dayjs from "dayjs";
import { sortGrid } from "../sortGrid";

const adaptAreaReport = (areaReport: IAreaReport[]) => {
	const flatData: any = {};

	areaReport.forEach((areaReport: IAreaReport) => {
		// new row, create a new object
		if (flatData[`k_${areaReport.area_id}`] === undefined) {
			flatData[`k_${areaReport.area_id}`] = {};

			flatData[`k_${areaReport.area_id}`]["name"] = areaReport.area_name;
			flatData[`k_${areaReport.area_id}`]["areaId"] = areaReport.area_id;
		}

		const key = dayjs()
			.month(areaReport.month - 1)
			.format("MMM");

		flatData[`k_${areaReport.area_id}`][key] = {
			complete: areaReport.complete_count,
			compliant: areaReport.compliant_count,
			passedThreshold: areaReport.store_threshold_count,
			month: areaReport.month,
			graded: areaReport.graded_count,
			totalUserCount: areaReport.total_user_count
		};
	});

	// Flatten the data
	const data = Object.keys(flatData).map((key) => flatData[key]);

	sortGrid(data, "name");

	return data;
};

export default adaptAreaReport;
